var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8WearProtectiveClothing502(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bLRv9OA4pMf1RqsQhtDcZa",
    x1: 15.478,
    x2: 34.518,
    y1: 0.586,
    y2: 52.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    stopColor: "#427fdb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.397,
    stopColor: "#2668cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.763,
    stopColor: "#1358bf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0c52bb"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "url(#bLRv9OA4pMf1RqsQhtDcZa)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M34.40492,22.4093,36.095,21.33977A1,1,0,0,0,36.40522,19.96L31.279,11.86A3.998,3.998,0,0,0,27.90068,10H27a.97939.97939,0,0,0-1-1H25V22a1,1,0,0,1-1,1h0a1,1,0,0,1-1-1V9H22a.97939.97939,0,0,0-1,1h-.89866A4.00055,4.00055,0,0,0,16.721,11.861L11.59485,19.96a1,1,0,0,0,.31022,1.37982l1.69,1.06951a1,1,0,0,0,1.37971-.31017L19,15.74v8.408L15.375,36.72209a1,1,0,0,0,.6839,1.23789l2.88316.831a1,1,0,0,0,1.23786-.684L23.381,27h1.238l3.202,11.1062a1,1,0,0,0,1.23783.68385l2.88319-.831a1,1,0,0,0,.68388-1.238L29,24.147V15.74l4.02522,6.35913A1,1,0,0,0,34.40492,22.4093Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8WearProtectiveClothing502);
export default __webpack_public_path__ + "static/media/icons8-wear-protective-clothing-50-2.97abef1e177f5b56be813ac689c95f1a.svg";
export { ForwardRef as ReactComponent };